import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ILeadRequest } from '@leads/shared/models/firebase/lead-request.model';
import { LoadingStateComponent } from '@shared/components/loading-state/loading-state.component';
import { PageSubtitleComponent } from '@shared/components/sections/page-subtitle/page-subtitle.component';

import { LatestLeadCardComponent } from '../latest-lead-card/latest-lead-card.component';

@Component({
	selector: 'app-latest-leads-table',
	imports: [CommonModule, PageSubtitleComponent, LatestLeadCardComponent, LoadingStateComponent],
	templateUrl: './latest-leads-table.component.html',
	styleUrl: './latest-leads-table.component.scss',
})
export class LatestLeadsTableComponent {
	@Input() isLoading: boolean;
	@Input() leads: Array<ILeadRequest> = [];
}
